<template>
    <div v-if="rubricIn">
        <b-modal
            id="rubric-edit-main-settings-modal"
            :title="$t('rubrics.edit_rubric_details')"
            size="md"
            :ok-title="$t('common.save')"
            @ok="onOk()"
            :cancel-title="$t('common.cancel')"
            cancel-variant="outline-primary"
            modal-class="apprentice-default-modal rubric-edit-title-modal">
            <div class="rubric-main-settings-edit">
                <b-form-group
                    :label="$t('common.title')"
                    label-for="rubric-edit-title-input">
                    <b-input
                        id="rubric-edit-title-input"
                        v-model="title"
                        placeholder="title"></b-input>
                </b-form-group>

                <b-form-group
                    class="rubric-edit-description-editor"
                    :label="$t('common.description')"
                    label-for="rubric-edit-description-editor">
                    <div class="ckeditor">
                        <ckeditor
                            v-model="description"
                            :editor="editor"
                            :config="editorConfig"></ckeditor>
                    </div>
                </b-form-group>
            </div>
        </b-modal>
    </div>
</template>

<script>
import ApprenticeEditor from '../../../../helpers/ApprenticeEditor';
import { ckeditorConfigs } from '../../../../helpers/CKEditorConfigs';

export default {
    name: 'design-2021-rubric-edit-title-and-description-modal-component',
    props: {
        rubricIn: Object
    },
    data() {
        return {
            title: this.rubricIn.title,
            description: this.rubricIn.description,
            editor: ApprenticeEditor,
            editorConfig: {
                ...ckeditorConfigs.rubrics,
                language: this.$authUser.locale
            }
        };
    },
    methods: {
        onOk() {
            const data = {
                title: this.title,
                description: this.description
            };

            this.alert.saving();
            this.axios.post(this.routes.updateRubric(this.rubricIn.id), data).then(
                (response) => {
                    this.rubricIn.update(data);
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                }
            );
        }
    },
    watch: {
        rubricIn: function(value) {
            this.title = value.title;
            this.description = value.description;
        }
    }
};
</script>

<style scoped>
.rubric-main-settings-edit >>> label {
    font-weight: 500;
    margin-bottom: 5px;
}

.rubric-main-settings-edit >>> .form-group {
    margin-bottom: 15px;
}

.rubric-main-settings-edit >>> input {
    padding: 8px 15px;
}
</style>
